// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-dialog[data-v-f55717b4] {\n  --mdc-dialog-min-width: 350px;\n  --mdc-dialog-max-width: 543px;\n  --mdc-dialog-z-index: 100000;\n}\n.dialog-icon[data-v-f55717b4] {\n  color: var(--vvd-color-on-canvas);\n  margin-bottom: 25px;\n}\n.text[data-v-f55717b4] {\n  white-space: pre-wrap;\n}\n", ""]);
// Exports
module.exports = exports;
